import {ActionReducerMap} from '@ngrx/store';

export interface RootState {
  // Empty - cart/wishlist removed
}

export const reducers: ActionReducerMap<RootState> = {};
